import React, { useEffect } from "react";
import { Redirect } from 'react-router-dom';
import { observer } from "mobx-react";

import { GuestEmail } from "components/GuestEmail";

import UIStore from "@/stores/UIStore";
import UserStore from "stores/UserStore";


export const StartQuote = observer(() => {

    useEffect(() => {
        UIStore.setSelectedKey(['quote']);
        UIStore.setDocumentTitle("Get Quote");

    }, []);


    // If user is authenticated go to one true form inside of account
    if (UserStore.isAuthenticated) {
        return <Redirect to={'/my-account/quote'}/>
    }

    // If user is a guest, Guest is saved a email on the localstorage
    if (UserStore.guest_email) {
        return <Redirect to={'/quote'}/>
    }


    // Otherwise display a input to enter an email address
    return <div style={{
        maxWidth: 600,
        margin: 'auto',
        // boxShadow: 'rgba(0, 0, 0, 0.3) 2px 2px 10px',
        padding: '15px',
        marginTop: '71px',
        border: 'solid 1px #d4d4d4'
    }}>
        <GuestEmail/>
    </div>

});
